import type { RouteObject } from "react-router-dom";

export const integrationsRoutes: Array<RouteObject> = [];
